/** How a single card ships: always in a sleeve; above this price (USD cents) also in a toploader. */
export const TOPLOADER_ABOVE_CENTS = 1000;

export function needsToploader(priceCents: number): boolean {
  return priceCents > TOPLOADER_ABOVE_CENTS;
}

export function packagingNote(priceCents: number, locale: "es" | "en"): string {
  if (locale === "en") return needsToploader(priceCents) ? "Shipped in a sleeve and a toploader." : "Shipped in a sleeve.";
  return needsToploader(priceCents) ? "Se envía con funda (sleeve) y toploader." : "Se envía con funda (sleeve).";
}
